const tasks = [
  { icon: 'ri-line-chart-line', title: 'Рост производительности', desc: 'Сотрудники работают быстрее и эффективнее. Производительность растёт на 15-30% после системного обучения.' },
  { icon: 'ri-brain-line', title: 'Развитие компетенций', desc: 'Целенаправленное развитие конкретных навыков: продажи, переговоры, управление, сервис, аналитика.' },
  { icon: 'ri-rocket-line', title: 'Ускорение адаптации', desc: 'Новые сотрудники выходят на плановые показатели в 2-3 раза быстрее. Onboarding перестаёт быть хаотичным.' },
  { icon: 'ri-heart-line', title: 'Удержание сотрудников', desc: '94% сотрудников остались бы в компании дольше, если бы она инвестировала в их обучение и развитие.' },
  { icon: 'ri-shield-star-line', title: 'Развитие лидерства', desc: 'Подготовка руководителей из внутреннего резерва. Управленцы понимают контекст бизнеса с первого дня.' },
  { icon: 'ri-funds-line', title: 'Рост продаж', desc: 'Обученные сотрудники продают больше. Конверсия растёт, средний чек увеличивается, повторные продажи учащаются.' },
  { icon: 'ri-customer-service-2-line', title: 'Повышение качества сервиса', desc: 'Единые стандарты обслуживания. NPS растёт. Клиенты возвращаются и рекомендуют компанию.' },
  { icon: 'ri-user-star-line', title: 'Подготовка кадрового резерва', desc: 'Системная подготовка сотрудников на ключевые позиции. Компания не зависит от одного-двух человек.' },
  { icon: 'ri-error-warning-line', title: 'Снижение ошибок', desc: 'Количество ошибок и повторных работ снижается на 20-40%. Стандарты и скрипты закрепляются.' },
  { icon: 'ri-team-line', title: 'Развитие корпоративной культуры', desc: 'Общие ценности, язык и подходы. Сотрудники понимают миссию компании и работают как единая команда.' },
];

export default function TasksSolved() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие задачи решает обучение персонала
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Системное развитие сотрудников закрывает сразу несколько бизнес-задач — от операционных до стратегических
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {tasks.map((t, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${t.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{t.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}